// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './generated/routes/_app'
import { Route as AppIndexRouteImport } from './generated/routes/_app/index'
import { Route as AppSecurityDocRouteImport } from './generated/routes/_app/security-doc'
import { Route as AppFormsDotteachingAssignmentRouteImport } from './generated/routes/_app/forms.teaching-assignment'
import { Route as AppFormsDotpostdocBursaryRouteImport } from './generated/routes/_app/forms.postdoc-bursary'
import { Route as AppFormsDotpostBiddingRouteImport } from './generated/routes/_app/forms.post-bidding'
import { Route as AppFormsDotmilitaryDeclarationRouteImport } from './generated/routes/_app/forms.military-declaration'

const AppRoute = AppRouteImport.update({
            id: '/_app',getParentRoute: () => rootRouteImport
          })
const AppIndexRoute = AppIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppRoute
          })
const AppSecurityDocRoute = AppSecurityDocRouteImport.update({
            id: '/security-doc',path: '/security-doc',getParentRoute: () => AppRoute
          })
const AppFormsDotteachingAssignmentRoute = AppFormsDotteachingAssignmentRouteImport.update({
            id: '/forms/teaching-assignment',path: '/forms/teaching-assignment',getParentRoute: () => AppRoute
          })
const AppFormsDotpostdocBursaryRoute = AppFormsDotpostdocBursaryRouteImport.update({
            id: '/forms/postdoc-bursary',path: '/forms/postdoc-bursary',getParentRoute: () => AppRoute
          })
const AppFormsDotpostBiddingRoute = AppFormsDotpostBiddingRouteImport.update({
            id: '/forms/post-bidding',path: '/forms/post-bidding',getParentRoute: () => AppRoute
          })
const AppFormsDotmilitaryDeclarationRoute = AppFormsDotmilitaryDeclarationRouteImport.update({
            id: '/forms/military-declaration',path: '/forms/military-declaration',getParentRoute: () => AppRoute
          })





const AppRouteChildren = {
  AppSecurityDocRoute: AppSecurityDocRoute,AppIndexRoute: AppIndexRoute,AppFormsDotmilitaryDeclarationRoute: AppFormsDotmilitaryDeclarationRoute,AppFormsDotpostBiddingRoute: AppFormsDotpostBiddingRoute,AppFormsDotpostdocBursaryRoute: AppFormsDotpostdocBursaryRoute,AppFormsDotteachingAssignmentRoute: AppFormsDotteachingAssignmentRoute
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren = {
  AppRoute: AppRouteWithChildren
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)